/** Replace {{CLIENT}}, {{TITLE}}, {{DATE}}, {{VERSION}} in a string. */
export function applyMetaPlaceholders(template, meta) {
  const title = meta.documentTitle.trim() || "Untitled document";
  const client = meta.clientName.trim() || "Client name";
  const date =
    meta.docDate.trim() ||
    new Intl.DateTimeFormat(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
    }).format(new Date());
  const version = meta.version.trim() || "1.0";

  return template
    .replace(/\{\{CLIENT\}\}/g, client)
    .replace(/\{\{TITLE\}\}/g, title)
    .replace(/\{\{DATE\}\}/g, date)
    .replace(/\{\{VERSION\}\}/g, version);
}
